import Admin from './containers/Admin';

export default Admin;
